import { useAuthentication } from "authentication/AuthenticationContext.js";
import { useNavigate, Link } from "react-router-dom";
import BaseButton from "base/BaseButton";
import FormTextField from "base/FormTextField";
import React, { useState } from "react";

const Login = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const { signIn } = useAuthentication();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await signIn(email, password);
      navigate("/"); // Redirect to home after login
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p1">
      <div className="max-w-md mx-auto">
        <h2 className="text-2xl font-bold mb-6">Login</h2>

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded">
            <p className="text-red-800 text-sm">{error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <FormTextField
            fieldLabel="Email"
            fieldType="email"
            value={email}
            onChange={setEmail}
            placeholder="Enter your email"
            required
            disabled={loading}
          />
          <FormTextField
            disabled={loading}
            fieldLabel="Password"
            fieldType="password"
            onChange={setPassword}
            placeholder="Enter your password"
            required
            value={password}
          />
          <BaseButton
            buttonClass="Green p-1 bord-5 Background-LGreen mb-3 mx-0"
            buttonType="submit"
            isDisabled={loading}
            type="submit"
            widthClass="w-100"
            buttonText={loading ? "Signing in..." : "Sign In"}
          />
        </form>

        <div className="text-center">
          <p className="text-sm">
            Don't have an account?{" "}
            <Link to="/signup" className="Green">
              Sign up
            </Link>
          </p>
          <p className="text-sm mt-2">
            <Link to="/forgot-password" className="Green">
              Forgot password?
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;